module.exports = __webpack_public_path__ + "img/i-seasons.82af91db.svg";